import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=2937ef3a&scoped=true&"
import script from "./Discover.vue?vue&type=script&lang=js&"
export * from "./Discover.vue?vue&type=script&lang=js&"
import style0 from "./Discover.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Discover.vue?vue&type=style&index=1&id=2937ef3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2937ef3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
